 
import { getFunctions, httpsCallable } from "firebase/functions";
import { getFirebaseApp } from "../../config/firebase/firebaseClient";
 
const functions = getFunctions(getFirebaseApp());  

 
export const callGetBocBalance = async (data) => {
  try {
    const getBocBalance = httpsCallable(functions, "getbocbalance");
    const result = await getBocBalance(data);
    return result.data;
  } catch (error) {
    console.error("Error calling getBocBalance function:", error);
    throw error;
  }
};
 export const callGetBocTransactions = async (data) => {
  try {
    const getbocTransactions = httpsCallable(functions, "getboctransactions");
    const result = await getbocTransactions(data);
    return result.data;
  } catch (error) {
    console.error("Error calling getbocTransactions function:", error);
    throw error;
  }
};
  export const callConvertTransactionToCSV= async (data) => {
  try {
    const converttransactiontocsv = httpsCallable(functions, "converttransactiontocsv");
    const result = await converttransactiontocsv(data);
    return result.data;
  } catch (error) {
    console.error("Error calling convertTransactionToCSV function:", error);
    throw error;
  }
};
 